import React from "react";
import CommentIcon from "./CommentIcon.svg";

/**
 * CommentBadge - Comment icon with a circular badge showing the number of comments
 * The badge appears at the top right of the icon
 */
export default function CommentBadge({ 
  commentCount, 
  onClick,
  size = "default" // "default" or "small"
}) {
  const count = commentCount || 0;
  const displayCount = count > 99 ? '99+' : count;
  
  // Size configurations
  const sizeConfig = {
    small: {
      iconSize: "16px",
      badgeSize: "14px",
      badgeFontSize: "9px",
      badgeTop: "-4px",
      badgeRight: "-4px"
    },
    default: {
      iconSize: "18px",
      badgeSize: "16px",
      badgeFontSize: "10px",
      badgeTop: "-5px",
      badgeRight: "-5px"
    }
  };
  
  const config = sizeConfig[size] || sizeConfig.default;
  
  return (
    <div
      onClick={onClick}
      style={{
        position: "relative",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: onClick ? "pointer" : "default",
        width: config.iconSize,
        height: config.iconSize
      }}
      title={`${count} comentario${count !== 1 ? 's' : ''}`}
    >
      {/* Comment Icon SVG */}
      <img 
        src={CommentIcon} 
        alt="comment" 
        style={{
          width: config.iconSize,
          height: config.iconSize,
          display: "block"
        }}
      />
      
      {/* Badge Circle with Number */}
      {count > 0 && (
        <div
          style={{
            position: "absolute",
            top: config.badgeTop,
            right: config.badgeRight,
            width: config.badgeSize,
            height: config.badgeSize,
            borderRadius: "50%",
            backgroundColor: "#EF4444", // Red background for badge (red-500)
            color: "#fff", // White text
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: config.badgeFontSize,
            fontWeight: "600",
            border: "1.5px solid #fff", // White border to separate from icon
            minWidth: config.badgeSize,
            boxSizing: "border-box",
            padding: "0 2px"
          }}
        >
          {displayCount}
        </div>
      )}
    </div>
  );
}

